import React, { useEffect, useState } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";

const PreviewPDF = ({ modalPdf, setModalPdf, title = "Archivo", fileName = 'report.pdf' }) => {
  const [pending, setPending] = useState(false);

  return (
    <Modal isOpen={modalPdf.show} className="modal-dialog modal-xl">
      <ModalHeader className="bg-primary">{title}</ModalHeader>
      <ModalBody>
        <div className="row">
          <iframe
            src={`${modalPdf.url}`}
            allowFullScreen
            style={{
              overflow: "auto",
              height: "500px",
              width: "100%",
            }}
          ></iframe>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={() => {
          var a = document.createElement("a"); //Create <a>
          a.href = modalPdf.url; //Image Base64 Goes here
          a.download = fileName; //File name Here
          a.click(); //Downloaded file
        }}>
          {" "}
          <i className="fa fa-download"></i> Descargar
        </Button>
        <Button color="secondary" onClick={() => setModalPdf({ show: false })}>
          {" "}
          <i className="fa fa-times"></i> Cerrar
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default PreviewPDF;
